export default __webpack_public_path__ + "static/media/val_conv_4.6ae9f298.png";